
export default {
  name: 'ListingEquities',

  data() {
    return {
      benefits: this.$t('benefits.blocks'),
    }
  },
}
